/** Audio device filter. */
export enum Filter {
  All = 'a',
  Local = 'l',
  Network = 'n'
}
